import { useState, useEffect } from 'react';
import { safeStorage } from './safeStorage';

// Função para rodar na inicialização e gravar no storage de forma segura
export const checkAndStorePlayStoreOrigin = () => {
  if (typeof window === 'undefined') return;
  
  try {
    const params = new URLSearchParams(window.location.search);
    const origin = (params.get('origem') || params.get('origin') || '').toLowerCase();
    const utmSource = (params.get('utm_source') || '').toLowerCase();
    const source = (params.get('source') || '').toLowerCase();
    const isTwa = params.get('twa') === '1' || params.get('twa') === 'true';

    // Se solicitado explicitamente modo web (útil para testes e alternância)
    if (origin === 'web' || origin === 'site' || source === 'web' || params.get('reset_playstore') === '1') {
      safeStorage.removeItem('isPlayStore');
      return;
    }

    // 1. Verificação por parâmetros de URL
    if (
      origin === 'googleplay' ||
      origin === 'playstore' ||
      utmSource === 'googleplay' ||
      utmSource === 'playstore' ||
      source === 'playstore' ||
      source === 'googleplay' ||
      isTwa
    ) {
      safeStorage.setItem('isPlayStore', 'true');
      return;
    }

    // 2. Verificação por Document Referrer do Android TWA
    if (typeof document !== 'undefined' && document.referrer && document.referrer.startsWith('android-app://')) {
      safeStorage.setItem('isPlayStore', 'true');
      return;
    }

    // 3. Verificação por WebView Android ou display-mode standalone no Android
    const userAgent = (navigator.userAgent || '').toLowerCase();
    const isAndroid = userAgent.includes('android');
    const isWebView = isAndroid && (userAgent.includes('wv') || userAgent.includes('version/4.0'));

    if (isWebView) {
      safeStorage.setItem('isPlayStore', 'true');
      return;
    }
  } catch (e) {
    console.warn('Erro ao processar detecção da Play Store:', e);
  }
};

// Leitura síncrona simples e segura
export const isPlayStoreApp = (): boolean => {
  if (typeof window === 'undefined') return false;
  return safeStorage.getItem('isPlayStore') === 'true';
};

// Hook customizado para usar nos componentes React
export const useIsPlayStore = () => {
  const [isPlayStore, setIsPlayStore] = useState(isPlayStoreApp());

  useEffect(() => {
    checkAndStorePlayStoreOrigin();
    setIsPlayStore(isPlayStoreApp());
  }, []);

  return isPlayStore;
};
